<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('listeProduitAchat.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('listeProduitAchat.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div
      class="column is-12 overflow-auto
      is-marginless hauteur-brief-filtre">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0"
        v-if="moduleImpressionAffiche">
          <libelle-tag-input
            :label="$t('catalogue.filtre.categorie')"
            :items="categorieProduit"
            v-model="critereRecherche.categorie">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitAchat.filtre.actif')">
            <b-select v-model="critereRecherche.actif">
              <option :value="null"></option>
              <option :value="true"> {{ $t('listeProduitAchat.filtre.yes') }}
              </option>
              <option :value="false"> {{ $t('listeProduitAchat.filtre.no') }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0" v-if="societesInformations.length > 1
        && !filtrerProduitParSociete">
          <b-field :label="$t('listeProduitAchat.filtre.societe')">
            <b-select v-model="critereRecherche.societeId" expanded>
              <option :value=null></option>
              <option v-for="societe in societesInformations"
                      :key="societe.id"
                      :value="societe.id">
                {{ societe.libelle }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()"
      >{{$t('listeProduitAchat.filtre.actions.appliquer')}}</button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()"
      >{{$t('listeProduitAchat.filtre.actions.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { SET_CRITERE } from '@/store/modules/produitAchat-mutation-type';
import genererCritereRechercheProduitAchat
  from '@/services/parametrage/produitAchat/genererCritereRechercheProduitAchat';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';

const Societes = createNamespacedHelpers('societe');
const ProduitAchat = createNamespacedHelpers('produitAchat');
const Parametres = createNamespacedHelpers('parametres');
const CategorieVente = createNamespacedHelpers('categorieVente');

export default {
  data() {
    return {
      critereRecherche: null,
    };
  },
  components: {
    libelleTagInput,
  },
  computed: {
    ...Societes.mapGetters({
      societesInformations: 'societesInformations',
    }),
    ...ProduitAchat.mapGetters({
      critereRechercheFromStore: 'criteresRecherche',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...CategorieVente.mapGetters({
      categorieProduit: 'categorieProduitAchat',
    }),
    moduleImpressionAffiche() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleImpressionAffiche.key);
    },
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...ProduitAchat.mapMutations({
      setCritereRecherche: SET_CRITERE,
    }),
    viderCritere() {
      this.critereRecherche = cloneDeep(genererCritereRechercheProduitAchat());
    },
    appliquerCritere() {
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
          PARAMETRES_INTERNE_KEYS.moduleImpressionAffiche.key]);
        this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
